import React, { useRef, useState } from "react";
import { TextField, Button, Box, Alert } from "@mui/material";

import ReCAPTCHA from "react-google-recaptcha";

const initialState = {
  nom: "",
  prenom: "",
  email: "",
  telephone: "",
  sujet: "",
  message: "",
};

const ContactForm = () => {
  const [formData, setFormData] = useState(initialState);
  const [status, setStatus] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!recaptchaToken) {
      setStatus("Veuillez valider le reCAPTCHA.");
      return;
    }

    // Ajout du token reCAPTCHA
    const formDataTmp = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataTmp.append(key, value);
    });
    formDataTmp.append("g-recaptcha-response", recaptchaToken);

    try {
      const response = await fetch(
        "https://amelieparis15.fr/scripts/sendContact.php",
        {
          method: "POST",
          body: formDataTmp,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      if (result.success) {
        setStatus("Message envoyé avec succès.");
        setFormData(initialState); // Réinitialiser le formulaire
        recaptchaRef.current.reset(); // Réinitialiser le reCAPTCHA
      } else {
        setStatus("Erreur : " + result.message);
        if (result.message === "Captcha invalide.") {
          // Réinitialiser le reCAPTCHA ici
          recaptchaRef.current.reset();
        }
      }
    } catch (err) {
      console.error(err);
      setStatus("Erreur d'envoi du formulaire.");
    }
    setRecaptchaToken(null); // reset token après usage
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate autoComplete="off">
      {["nom", "prenom", "email", "telephone", "sujet"].map((field) => (
        <TextField
          key={field}
          name={field}
          label={field.charAt(0).toUpperCase() + field.slice(1)}
          value={formData[field]}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
      ))}

      <TextField
        name="message"
        label="Message"
        value={formData.message}
        onChange={handleChange}
        multiline
        rows={6}
        fullWidth
        margin="normal"
        required
      />

      <ReCAPTCHA
        style={{ marginTop: "1rem" }}
        ref={recaptchaRef}
        sitekey="6Ldw8zwrAAAAAHJ3vfjq9-Vk1ZMOl629lNbdmspn"
        onChange={(token) => {
          // token est automatiquement envoyé quand l'utilisateur coche
          console.log(token);
          setRecaptchaToken(token);
        }}
      />

      <Button
        type="submit"
        variant="contained"
        sx={{
          mt: 2,
          borderRadius: 0,
          backgroundColor: "#000",
          color: "#fff",
          width: "100%",
          padding: "12px",
          fontWeight: "bold",
          "&:hover": { backgroundColor: "#333" },
        }}
      >
        Envoyer
      </Button>

      {status && (
        <Alert
          sx={{ mt: 2 }}
          severity={status.includes("Erreur") ? "error" : "success"}
        >
          {status}
        </Alert>
      )}
    </Box>
  );
};

export default ContactForm;
